import React from "react";
import { Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { cartSubtotal, formatMoney } from "../../utils/cartPricing";

export default function CartTotal() {
  const items = useSelector((state) => state.cartSlice.items);
  return <div className="cart-container">
    <h3>Din varukorg</h3>
    <Divider className="my-3" />
    <div className="car-pricing"><p>Delsumma</p><p>{formatMoney(cartSubtotal(items))}</p></div>
    <p>Frakt och eventuella kuponger beräknas i kassan. Slutpriset bekräftas innan du beställer.</p>
  </div>;
}
